/** @jsx jsx */
import { jsx } from "theme-ui"
import { Fragment, useState, useEffect } from "react" // redundant React import, see https://github.com/system-ui/theme-ui/issues/195
import { keyframes } from "@emotion/core"
import { useTranslation } from "react-i18next"

import marks from "../../../images/marks"

const brStyle = { display: ["block", "none"] }

const words = [
  {
    start: "My",
    finish: "City",
  },
  {
    start: "Ma",
    finish: "ville",
  },
  {
    start: "Mi",
    finish: "ciudad",
  },
  {
    start: "我的城市",
    finish: "",
    style: {
      mt: [1, 0],
    },
  },
  {
    start: "مدينتي",
    finish: "",
    style: {
      mt: [1, 0],
    },
  },
]

const textAnimationDuration = 500
const textAnimationDelay = 800
const wordsInterval = 1200

const textOpacity = keyframes`
  0% {
    transform: translateY(10px);
    opacity: 0
  }
  100% {
    transform: translateY(0);
    opacity: 1
  }
`

const MainTitle = ({ subtitle }) => {
  const { i18n } = useTranslation()
  const [currentIndex, setCurrentIndex] = useState(0)
  const [hasAnimated, setAnimated] = useState(false)

  useEffect(() => {
    let timeout = null
    let interval = null

    if (window.isLandingAnimationComplete) {
      setAnimated(true)
    } else {
      if (!timeout) {
        timeout = setTimeout(() => {
          setAnimated(true)
          const event = new Event("landingTitleAnimationEnd")
          window.dispatchEvent(event)
        }, 500)
      }
    }

    if (hasAnimated) {
      interval = setInterval(() => {
        let nextIndex = 0
        if (currentIndex === words.length - 1) {
          nextIndex = 0
        } else {
          nextIndex = currentIndex + 1
        }

        setCurrentIndex(nextIndex)
      }, wordsInterval)
    }

    return () => {
      clearInterval(interval)
      clearTimeout(timeout)
    }
  }, [hasAnimated, currentIndex])

  const word = (start, finish, style = {}, index) => {
    return (
      <span
        key={index}
        sx={{
          position: index === 0 ? "relative" : "absolute",
          top: 0,
          [`${i18n.dir() === "rtl" ? "right" : "left"}`]: 0,
          color: "primary",
          opacity: currentIndex === index ? 1 : 0,
          transition: "opacity 0.4s",
          transitionDelay: currentIndex === index ? "0.4s" : 0,
          whiteSpace: "nowrap",
          ...style,
        }}
      >
        {start} <br sx={brStyle} />
        {finish}
      </span>
    )
  }

  return (
    <Fragment>
      <div
        sx={{
          variant: "styles.root.h1",
          display: ["block", "flex"],
          alignItems: ["initial", "center"],
          justifyContent: ["initial", "center"],
          mb: 0,
          fontSize: [8, 8, 8, 10],
          textAlign: [i18n.dir() === "rtl" ? "right" : "left", "center"],
          lineHeight: 0.9,
        }}
      >
        <span
          sx={{
            display: "inline-flex",
            backgroundImage: `url(${marks.mark6})`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: [
              `${i18n.dir() === "rtl" ? "-70px" : "70px"} 0`,
              i18n.dir() === "rtl" ? "left center" : "right center",
            ],
            backgroundSize: ["66px auto", "auto 100%"],
            [`${i18n.dir() === "rtl" ? "pl" : "pr"}`]: "40px",
            py: 2,
            pb: [0, 2],
          }}
        >
          <span
            sx={{
              animation: `${textOpacity} ${textAnimationDuration /
                1000}s ${textAnimationDelay / 1000}s 1 ease-out both`,
            }}
          >
            My <br sx={brStyle} /> Mark
          </span>
        </span>
        <br sx={brStyle} />
        <div
          sx={{
            position: "relative",
            animation: `${textOpacity} ${textAnimationDuration /
              1000}s ${(textAnimationDelay + 100) / 1000}s 1 ease-out both`,
          }}
        >
          {words.map((item, index) => {
            return word(item.start, item.finish, item.style, index)
          })}
        </div>
      </div>
      <h4
        sx={{
          variant: "text.body",
          textAlign: [i18n.dir() === "rtl" ? "right" : "left", "center"],
          mt: [4, 3],
          opacity: hasAnimated ? 1 : 0,
          transition: "opacity 2s 1s",
          maxWidth: ["190px", "none"],
        }}
      >
        {subtitle}
      </h4>
    </Fragment>
  )
}

export default MainTitle
